const isFunction = (maybeFunction) => typeof maybeFunction === 'function'

export default isFunction
